module.exports = __webpack_public_path__ + "static/juno-logo-7d948109d15b124484c69b8de0151445.png";